export const id_netscape = "2.16.840.1.113730";
export const id_netscapeCertExtension = `${id_netscape}.1`;
